import { useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ReactPaginate from "react-paginate";
// import { data } from "../../data/products";
// import ProductCard from "../Shared/Product/ProductCard";

function Items({ currentItems, element, containerClassName }) {
  return (
    <>
      <div>
        <div
          className={
            containerClassName || "grid grid-cols-5 justify-items-center"
          }
        >
          {currentItems && currentItems.map((item) => element(item))}
        </div>
      </div>
    </>
  );
}

const Paginate = ({ itemsPerPage, element, data, containerClassName }) => {
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = data.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <Items
        currentItems={currentItems}
        element={element}
        containerClassName={containerClassName}
      />
      <ReactPaginate
        breakLabel="..."
        nextLabel={<IoIosArrowForward />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={<IoIosArrowBack />}
        renderOnZeroPageCount={null}
        className="m-8 flex items-center justify-center gap-2 rounded-[10px] border border-lightGray"
        pageClassName="cursor-pointer bg-paginateBgGray my-4 rounded-[5px]"
        pageLinkClassName="text-xs px-5 py-3 block font-pop font-bold text-textColor"
        activeClassName="!bg-primary text-white"
        activeLinkClassName="text-xs font-pop font-bold !text-white"
        nextClassName="text-primary text-3xl cursor-pointer stroke-2"
        previousClassName="text-primary text-3xl cursor-pointer stroke-2"
      />
    </>
  );
};

export default Paginate;
